import { FileType } from 'state';

export const getFileStartAndEndTime = (files: FileType[], fileId: string) => {
  const fileIndex = files.findIndex(f => f.id === fileId);
  const file = files[fileIndex];

  if (!file) return { fileStartTime: 0, fileEndTime: 0 };

  const fileStartTime = files
    .filter((f, i) => i < fileIndex)
    .reduce((total, file) => total + (file.fileLengthSeconds || 0), 0);

  const fileEndTime = fileStartTime + (file.fileLengthSeconds || 0);

  return {
    fileStartTime,
    fileEndTime,
  };
};

export const getInspectionDuration = (files: FileType[]) => {
  return files.reduce((total, file) => total + (file.fileLengthSeconds || 0), 0);
};

export const getFileAtTime = (
  files: FileType[],
  /** time within the overall inspection time */
  time: number,
): { file: FileType | undefined; timeWithinFile: number } => {
  const file = files.find(f => {
    const { fileStartTime, fileEndTime } = getFileStartAndEndTime(files, f.id);

    return time >= fileStartTime && time < fileEndTime;
  });

  const timeWithinFile = file
    ? time - getFileStartAndEndTime(files, file.id).fileStartTime
    : 0;

  return {
    file,
    timeWithinFile,
  };
};
